export
const name: string = "Skybox";

export
const preproc: string = ``;

export
const declaration: string = `
    // override default precision specified in defaultPrecision_fs
    precision mediump float;

    uniform SMaterial u_material;
`;

export
const varyings: string = `
    varying vec2  v_tex_coord;
    varying float v_selected;
`;

export
const implementation: string = `
    void main()
    {
        // in chrome when chrome://gpu show that "Canvas: Software only, hardware acceleration unavailable"
        // then returning from function to struct members does not work
        SMaterial surfaceMat = applyTextureToSurface(u_material, v_tex_coord);

        gl_FragColor = clamp(vec4(surfaceMat.ambient + surfaceMat.diffuse + surfaceMat.specular, surfaceMat.alpha), 0.0, 1.0);
    }
`;
